export default __webpack_public_path__ + "media/zurb/img/events/wired/wired-img1-94870a5cf0fb5928f58ce204c369ca3b.png";